import * as api from '../helper/api'

export function request(endpoint, options = {}) {
    return (dispatch, getState) => {
        // get token and add to request
        if (true || options.method && !options.method.match(/get/i)) {
            const token = getState().token
            if (token) {
                options.params = Object.assign(options.params || {}, { token })
            }
        }
        return api.request(endpoint, options)
    }
}


// WEBPACK FOOTER //
// ./actions/api.js